<template lang="html">
    <div class="d-flex flex-column h-100">

        <div class="ticketPriceContainer flex-grow overflow-auto">
            <reservation-ticket-price
                :personPrice="personPrice"
                :reservation="reservation"
                :isEditing="editingPax"
                v-for="(personPrice, index) in orderedBookingGenderPrices"
                :key="index"
            />
        </div>

        <div class="mb-1 d-flex flex-row align-items-center mt-2">
            <div class="fs-largest darker font-weight-600 flex-grow-1">
                Total Pax: {{totalPax}}
            </div>
            <button class="btn tertiary" v-tooltip="editBtnTooltip" :disabled="disableEditBtn || isReservationReadOnly && reservation.status != -5" @click="toggleEditPax">{{editingPax? 'Apply' : 'Edit'}}</button>
        </div>
    </div>
</template>

<script>
import {mapActions} from 'vuex'
import { reservationsMixin } from '@/mixins/reservations'
import reservationTicketPrice from './reservationTicketPrice.vue'
export default {
    mixins: [
        reservationsMixin,
    ],
    props: {
        reservation: {
            type: Object,
            required: true
        }
    },
    data: function () {
        return {
            editingPax: false,
        }
    },
    computed: {
        disableEditBtn: function () {
          return false
        },
        editBtnTooltip:function () {
            return this.disableEditBtn == true? 'Only available if price is set "Per Person", this event is sold "Per order"' : null
        },
        orderedBookingGenderPrices() {
            return this.reservation.bookingGenderPrices;
        },
    },
    methods: {
        ...mapActions([
            'setReservationCalculations',
        ]),
        updateCalculations: function () {
            return this.setReservationCalculations(this.reservation)
        },
        toggleEditPax: function () {
            if(this.isReservationReadOnly){
                this.readOnlyShowMessage()
                return false
            }

            if(this.editingPax){
                if(this.reservation.paxCheckedIn > this.totalPax){
                    this.reservation.paxCheckedIn = this.totalPax
                }

                if(this.reservation.paxNoShow > this.totalPax){
                    this.reservation.paxNoShow = this.totalPax
                }
                if(this.reservation.bookingGenderPrices[0].genderPriceType != 1){
                     if (this.totalPax === 0) {
                         this.$toasted.info('Not allowed to set the reservation occupancy to 0 guests.')
                         return false
                     }
                }
                
                this.updateCalculations(this.reservation).then(() => {
                })
            }

            this.editingPax = !this.editingPax
            this.$emit('toggleEditPax', this.editingPax)
        },
    },
    components:{
        reservationTicketPrice
    }
}
</script>


// WEBPACK FOOTER //
// reservationTicketPrices.vue?739c2d4a